import { RULES } from '../../constants';

import { StepItem } from '../StepItem';

import styles from './StepsSection.module.scss';

const StepsSection = () => (
  <ul className={styles.rulesContainer}>
    {RULES.map((item) => (
      <StepItem key={item.title} item={item} />
    ))}
  </ul>
);

export default StepsSection;
